module.exports = __webpack_public_path__ + "static/media/ghuser.7541a538.JPG";